export * from './badge-status-cabecalho-conferencia-de-fatura.pipe';
